/*
 * @Author: 陈力恒
 * @LastEditors: 陈力恒
 * @Date: 2022-05-05 10:11:57
 * @LastEditTime: 2022-06-16 11:13:59
 * @Description: 配送毛利model
 */
import type {
  IDistributionGrossProfitModel,
  IDistributionGrossProfitStore,
} from '@monorepo/types/orders/distributionGrossProfit/distributionGrossProfit.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IDistributionGrossProfitStore = {
  isInit: true,
  tableList: [],
  locationTableList: [],
  total: 0,
  locationTableTotal: 0,
  query: {
    productPageSize: 50,
    productPage: 1,
    locationPageSize: 50,
    locationPage: 1,
    date_type: 'AUDIT_DATE',
    location_sort_order: 'OUT_LOCATION_NAME_DESC',
    product_sort_order: 'OUT_LOCATION_NAME_DESC',
    date: getToday(),
    query_type: 'LOCATION',
  },
};

const distributionGrossProfitStore: IDistributionGrossProfitModel = {
  namespace: 'distributionGrossProfitStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default distributionGrossProfitStore;
